import { o, replace } from 'ramda';

export const removePx = o(Number, replace('px', ''));
